/* eslint-disable @typescript-eslint/no-non-null-assertion */
/**
 * Забирает номер телефона. Почувствуй себя в рубях.
 */
import { IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getPhoneText(user?: IUserSchema | null): string {
  const hasPhones = user && user.isAuthenticated && user.phones;

  // tslint:disable-next-line:no-non-null-assertion
  return hasPhones && user!.phones![0] && user!.phones![0].phone ? user!.phones![0].phone! : '';
}
